import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const deleteListOfRequest = async (
  listRequestID?: string[],
  userUp?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaDashboard.deleteListOfRequest,
    JSON.stringify({
      ListRequestID: listRequestID,
      UserUp: userUp,
    })
  );

  return dataAPI.data.data;
};

export const getTopTenRequestData = async (
  roleId?: string,
  binusianID?: string,
  searchText?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaDashboard.getTop10_RequestData,
    JSON.stringify({
      RoleId: roleId,
      SearchText: searchText,
      BinusianID: binusianID,
    })
  );

  return dataAPI.data.data;
};
